import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { Subject, filter, switchMap } from 'rxjs';

@Injectable()
export class TranslatedTitleStrategy extends TitleStrategy {
  private readonly titleResource = new Subject<string>();

  constructor(private readonly title: Title, private readonly translocoService: TranslocoService) {
    super();
    this.titleResource
      .pipe(
        switchMap((x) => this.translocoService.selectTranslateObject(x)),
        filter((x) => !!x)
      )
      .subscribe((x) => this.title.setTitle(x));
  }

  override updateTitle(routerStateSnapshot: RouterStateSnapshot) {
    const title = this.buildTitle(routerStateSnapshot);
    if (title !== undefined) {
      this.titleResource.next(title);
    }
  }
}
